import axios from 'axios'
import { useToast } from 'vue-toastification'

const toast = useToast()

// Create axios instance
const api = axios.create({
    baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3006/api/v1',
    
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json'
    }
})

// Request interceptor
api.interceptors.request.use(
    (config) => {
        // Add session ID to headers
        const sessionId = localStorage.getItem('sessionId')
        if (sessionId) {
            config.headers['x-session-id'] = sessionId
        }

        // Add timestamp for cache busting
        if (config.method === 'get') {
            config.params = {
                ...config.params,
                _t: Date.now()
            }
        }

        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

// Response interceptor
api.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
        const message = error.response?.data?.error || error.message || 'An error occurred'

        // Don't show toast for certain errors
        const silentErrors = [404, 401]
        if (!silentErrors.includes(error.response?.status)) {
            toast.error(message)
        }

        return Promise.reject(error)
    }
)

export default api
